export const ORDER_STATUS = {
    ONVOLTOOID: 0,
    WAG: 1, 
	BESTEL:2,
	INGEDIEN:3,
    GOEDGEKEUR:4,
    AFGEKEUR:5,
    KANSELLEER:6
}